// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class HolidayResult  {
    _originalTypeClassName = "Loom.BO.HolidayResult";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
HolidayResult.translate = translateService;
}
this.IsHoliday = false;
this.HolidayName = null;
this.HolidayResultKey = null;
this._key = this.HolidayResultKey = 0; 
}

static translate: TranslateService;
_key: any;
IsHoliday:any;
HolidayName:any;
private _HolidayResultKey:any;
get HolidayResultKey(): any {
    return this._HolidayResultKey;
  }
set HolidayResultKey(value: any) {
    this._HolidayResultKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.HolidayResultKey == null || $this.HolidayResultKey == 0;
            }


}